import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { StringRequiredSchema } from '@/utils';

const CheckoutFormSchema = z.object({
  card_number: z.string().min(16, 'Invalid card number'),
  expiration_month: StringRequiredSchema('Required'),
  expiration_year: StringRequiredSchema('Required'),
  cvc: StringRequiredSchema('Required'),
  total: z.number(),
});

export type CheckoutForm = z.infer<typeof CheckoutFormSchema>;

export const checkoutFormDefaultValues: CheckoutForm = {
  card_number: '',
  expiration_month: '',
  expiration_year: '',
  cvc: '',
  total: 0,
};

export const useCreateCheckoutForm = () => {
  const form = useForm({
    resolver: zodResolver(CheckoutFormSchema),
    defaultValues: checkoutFormDefaultValues,
  });

  return form;
};
